import { InfluencerIdProvider } from '@client/new/contexts/InfluencerIdContext';
import { useCollectionVM } from './collection.viewModel';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { Program } from './program';
import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import {
  InjectedRouter,
  PlainRoute,
  RouteComponentProps,
} from '@client/router/compat';
import { RoutingProvider } from '@client/new/hooks/useRouting';

type Props = RouteComponentProps<
  {
    influencerId: string;
    programId: string;
    route: PlainRoute<unknown>;
    router: InjectedRouter;
  },
  unknown
>;

const CollectionPageContent = (props: Props) => {
  const { params, router, route, location } = props;
  const { programId, influencerId } = params;

  const data = useCollectionVM({
    collectionId: Number(programId),
    creatorId: Number(influencerId),
    router,
    route,
    programDerivedState: location.query.programDerivedState ?? null,
  });

  const routing = { router: props.router, route: props.route };

  return (
    <RoutingProvider routing={routing}>
      <InfluencerIdProvider value={Number(influencerId)}>
        <AsyncRenderer
          loadRender={<TableLoader rows={5} />}
          data={data}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderer={(p) => <Program {...(p as any)} />}
        />
      </InfluencerIdProvider>
    </RoutingProvider>
  );
};

// A new programId must not inherit the previous program's validation state.
export const CollectionPage = (props: Props) => (
  <CollectionPageContent key={props.params.programId} {...props} />
);
